export default "__VITE_ASSET__b9b1c8fa__"